const AddCard = () => import("@/components/BankCard/AddCard/index");
export default {
  name: "not-registered-card",
  components: { AddCard },
  props: ["data"],
  data() {
    return {
      addCardDialog: false
    };
  },
  computed: {},
  mounted() {},
  methods: {
    handleAddCard() {
      this.$emit("confirmOrder", false);
      this.addCardDialog = true;
    }
  }
};
